<template>
	<div class="cover-container" @click="coverIconClick">
		<div class="cover-icon" v-if="coverIcon && !loader" v-html="svgStore.get(coverIcon)"></div>
		<div class="cover-value" v-if="!loader">{{ coverValue }}</div>
		<AppLoader v-if="loader" color="var(--color-secondary)" :size="14" />
	</div>
</template>

<script>
import {useSvgStore} from "@/shared/stores";
import AppLoader from "@/shared/components/AppLoader.vue";

export default {
	components: {AppLoader},
	setup() {
		const svgStore = useSvgStore();
		return {svgStore};
	},
	props: {
		coverIcon: {
			type: String
		},
		coverValue: {
			type: String
		},
		loader: {
			type: Boolean,
			default: false
		}
	},
	name: 'TopNavbarCoverIcon',
	emits: ['click'],
	methods: {
		coverIconClick() {
			this.$emit('click');
		}
	},
}
</script>

<style scoped lang="scss">
.cover-container {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	box-shadow: inset 0 0 3px var(--color-box-shadow-3);
	background-color: var(--color-alpha-1);
	border-radius: 7px;
	padding: 9px 8px;
	gap: 5px;
	cursor: pointer;
	border: 1px solid var(--color-primary);

	.cover-icon {
		width: 14px;
		height: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		animation: shakePulse .5s 2 ease-in-out;

		&:deep(svg) {
			width: 100%;
			height: 100%;

			.fill {
				fill: var(--color-svg-primary);
			}

			.stroke {
				stroke: var(--color-svg-primary);
			}
		}
	}

	.cover-value {
		font-size: 14px;
		font-weight: 500;
		color: var(--color-primary);
	}
}

@keyframes shakePulse {
	0% { transform: scale(1) rotate(0deg); }
	20% { transform: scale(1.1) rotate(5deg); }
	40% { transform: scale(1.3) rotate(-15deg); }
	60% { transform: scale(1.1) rotate(5deg); }
	80% { transform: scale(1) rotate(-5deg); }
	100% { transform: scale(1) rotate(0deg); }
}

@keyframes slideInFromLeft {
	0% {
		opacity: 0;
		transform: translateX(-100%) scale(.6);
	}
	100% {
		opacity: 1;
		transform: translateX(0) scale(1);
	}
}

.cover-container {
	animation: slideInFromLeft .3s ease;
}
</style>